<template>
  <v-app-bar
    app
    clipped-left
    clipped-right
    :color="navbarColor"
    :dark="navbarColor !== 'white'"
  >
    <!---Logo part -->
    <v-toolbar-title
      class="align-center d-flex logo-width"
      v-if="navbarColor !== 'white'"
    >
      <span class="logo-text ml-2">
        <h3>{{ this.channel.name }}</h3>
      </span>
    </v-toolbar-title>
    <div>
      <v-app-bar-nav-icon
        @click="
          $vuetify.breakpoint.smAndDown
            ? setSidebarDrawer(!Sidebar_drawer)
            : $emit('input', !value)
        "
      />
    </div>
    <!---/Toggle sidebar part -->
    <v-spacer />
    <!---right part -->

    <!---업로드 작업현황 메뉴 -->
    <v-avatar
      size="40"
      v-if="$store.state.uploadingContent.length > 0"
      @click="showUploadToggle"
    >
      <v-icon lg>mdi-autorenew mdi-spin</v-icon>
    </v-avatar>
    <v-menu
      ref="uploadMenu"
      v-model="showUpload"
      absolute
      :position-x="showUploadPosition_x"
      :position-y="showUploadPosition_y"
    >
      <v-list>
        <v-list-item
          v-for="(item, i) in this.$store.state.uploadingContent"
          :key="i"
        >
          <v-list-item-content>
            <v-list-item-title
              class="caption text-truncate"
              style="width: 250px;"
              >{{ item.file_name }}
              <v-progress-linear
                v-model="item.progress"
                color="lime"
                striped
                class="mt-2 caption"
                height="20"
              >
                <template v-slot:default="{ value }">
                  <strong v-if="item.status != 'failed'"
                    >{{ Math.ceil(value) }}%</strong
                  >
                  <strong v-if="item.status == 'failed'">Failed</strong>
                </template>
              </v-progress-linear>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="abort(item.file_id)">
              <v-icon color="grey lighten-1">mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn dark icon v-on="on" class="mr-1">
          <v-avatar size="40">
            <v-icon lg>mdi-cog</v-icon>
          </v-avatar>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, i) in userprofile"
          :key="i"
          @click="clickProfile(item.action)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- 셋팅창모달 -->
    <v-dialog v-model="settingdialog" max-width="400">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Setting</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="settingdialog = false">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          Locale
          <div class="black--text">
            - Service will be provided in the future.
          </div>
          <!-- <v-form ref="form" color="channel"
            ><locale-switcher></locale-switcher>
          </v-form> -->
        </v-card-text>
        <v-card-text>
          Channel Name
          <v-row>
            <v-col cols="10">
              <v-text-field
                :disabled="isChannelNameDisabled"
                v-model="channelNameForEdit"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="justify-center">
              <v-btn
                v-on:click="isChannelNameDisabled = false"
                v-if="isChannelNameDisabled"
                icon
                class="mt-3 ml-4"
              >
                <v-icon lg>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-on:click="channelNameSave()"
                v-if="!this.isChannelNameDisabled"
                icon
                class="mt-3 ml-4"
              >
                <v-icon lg>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          Profile Image
          <v-row>
            <v-col cols="12">
              <v-avatar v-if="!!this.channel.profileImage" class="mt-2 ml-2">
                <img v-bind:src="this.profileImageUrl" alt="Channel Profile" />
              </v-avatar>
              <v-btn
                @click="profileImageDelete()"
                v-if="!!this.channel.profileImage"
                icon
                class="mt-3 ml-4"
              >
                <v-icon lg>mdi-trash-can</v-icon>
              </v-btn>
              <v-form
                ref="form"
                v-if="!this.channel.profileImage"
                v-model="valid"
                lazy-validation
              >
                <v-file-input
                  v-model="file"
                  :rules="fileRules"
                  accept="image/png, image/jpeg"
                  placeholder="Select your profile"
                  prepend-icon="mdi-account-circle"
                  @change="profileImageSave()"
                  color="channel"
                ></v-file-input>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 셋팅창모달 끝-->
  </v-app-bar>
</template>
<script>
// Utilities
import { mapState, mapMutations } from "vuex";
import store from "../../../store";
//import LocaleSwitcher from "../../../components/LocaleSwitcher.vue";
import { createFile, updateChannelByCM, deleteFile } from "@/graphql/Mutation";

export default {
  name: "VerticalHeader",

  components: {
    // "locale-switcher": LocaleSwitcher
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // console.log(this.channelName, this.$store.state.channelName);
    setTimeout(() => {
      this.channelNameForEdit = this.channel.name;
    }, 1000);
  },
  data: () => ({
    showUploadFirst: true,
    showUpload: false,
    showUploadPosition_y: 56,
    isChannelNameDisabled: true,
    channelNameForEdit: null,
    file: null,
    name: "",
    valid: true,
    uploading: false,
    uploadSuccess: null,
    deleteSuccess: null,
    fileRules: [
      file =>
        !file || file.size < 1e9 || "Avatar size should be less than 2 MB!"
    ],
    showLogo: true,
    showSearch: false,
    settingdialog: false,
    userprofile: [
      { title: "Setting", action: "setting" },
      { title: "Reset Password", action: "resetPassword" },
      { title: "Signout", action: "signout" }
    ]
  }),

  computed: {
    ...mapState([
      "navbarColor",
      "Sidebar_drawer",
      "channel",
      "uploadingContent"
    ]),
    profileImageUrl: function() {
      return (
        process.env.VUE_APP_BASE_URL +
        `/pub/channel/${this.channel.channelId}/profile/` +
        this.channel.profileImage
      );
    },
    showUploadPosition_x: function() {
      const w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      return w;
    }
  },

  watch: {
    uploadingContent: {
      handler: function(newVal) {
        //console.log({ newVal, oldVal });
        if (this.showUploadFirst) {
          this.showUpload = true;
          this.showUploadFirst = false;
        }
        if (newVal.length == 0) {
          this.showUploadFirst = true;
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setSidebarDrawer: "SET_SIDEBAR_DRAWER"
    }),
    // showhideLogo: function() {
    //   this.showLogo = !this.showLogo;
    // },
    // searchbox: function() {
    //   this.showSearch = !this.showSearch;
    // },
    href() {
      return undefined;
    },
    showUploadToggle(e) {
      e.preventDefault();
      if (this.showUpload) {
        this.showUpload = false;
      } else {
        this.showUpload = true;
      }
      console.log(this.showUpload);
    },
    async channelNameSave() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: updateChannelByCM,
          variables: {
            id: this.channel.channelId,
            name: this.channelNameForEdit
          },
          fetchPolicy: "no-cache"
        });
        if (data) {
          console.log(data);
          this.$store.commit("SET_CHANNEL_NAME", data.updateChannel.name);
          this.isChannelNameDisabled = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async profileImageSave() {
      let returnedFileName;

      if (!this.$refs.form.validate()) return;
      if (!this.file) return;
      console.log("Loading...");
      this.uploading = true;
      try {
        const { data } = await this.$apollo.mutate({
          mutation: createFile,
          variables: {
            name: this.file.name,
            fileType: this.file.type,
            channel_id: this.channel.channelId,
            mode: "profile"
          },
          fetchPolicy: "no-cache"
        });

        if (data) {
          returnedFileName = data.createFile.name;
          try {
            console.log("presigned Url", data.createFile.url);
            await this.$axiosS3Public.put(data.createFile.url, this.file, {
              headers: { "Content-Type": this.file.type }
            });
            console.log("Loaded");
            this.uploading = false;
            this.uploadSuccess = true;
          } catch (e) {
            // do we need to remove anything from the model here?
            console.log("Upload failed!", e);
            this.uploadSuccess = false;
          }
        }
      } catch (e) {
        console.log("Upload Eror", e);
      }

      if (this.uploadSuccess) {
        this.channel.profileImage = returnedFileName;
        this.$store.commit("SET_CHANNEL", this.channel);

        this.$notify({
          group: "Success",
          title: "Profile Upload",
          type: "success",
          text: "Uploaded your profile successfully"
        });
      }

      this.file = null;
    },
    async profileImageDelete() {
      try {
        await this.$apollo.mutate({
          mutation: deleteFile,
          variables: {
            name: this.channel.profileImage,
            channel_id: this.channel.channelId,
            mode: "profile"
          },
          fetchPolicy: "no-cache"
        });
        this.deleteSuccess = true;
      } catch (e) {
        this.deleteSuccess = false;
        console.log("profile delete error", e);
      }
      if (this.deleteSuccess) {
        this.channel.profileImage = null;
        this.channel.profileImageUrl = null;

        this.$store.commit("SET_CHANNEL", this.channel);

        this.$notify({
          group: "Success",
          title: "Profile Image",
          type: "success",
          text: "Deleted your profile successfully"
        });
      }
    },
    async resetPassword() {
      const user = store.state.user;
      if (user && user.email) {
        console.log(user.email);
        const path = "/auth/forgot-password?email=" + user.email;
        try {
          // console.log(this.$axiosAuth);
          const data = await this.$axiosAuth.get(path);
          if (data && data.status == 200) {
            this.$notify({
              type: "success",
              title: "Reset Password",
              text:
                "An email has been sent to change the password. Please change your password through the link sent in the e-mail.",
              duration: 5000,
              closeOnClick: true
            });
          }
        } catch (e) {
          console.log(e);
          const msg = e.response.data.message;
          this.$notify({
            type: "error",
            title: "Reset Password",
            text: msg,
            duration: 5000,
            closeOnClick: true
          });
        }
      }
    },
    async clickProfile(action) {
      //return undefined;
      console.log(this);
      switch (action) {
        case "resetPassword":
          try {
            await this.resetPassword();
          } catch (e) {
            console.log("ResetPassword Error", e);
          }
          break;
        case "setting":
          this.settingdialog = true;
          break;
        case "signout":
          try {
            await store.dispatch("signOut");
          } catch (e) {
            console.log("SignOut Error", e);
          }
          break;
        default:
          break;
      }
    },
    abort(file_id) {
      this.$store.dispatch("abortVideo", file_id);
    }
  }
};
</script>

<style lang="scss">
.hidelogo {
  display: none;
}
.searchinput {
  position: absolute;
  width: 100%;
  margin: 0;
  left: 0;
  z-index: 10;
  padding: 0 15px;
}
.descpart {
  max-width: 220px;
}
.localeBox {
  max-width: 100px;
  margin-left: 15px;
  height: 40px;
}
</style>
